import { RecordKind } from '../api/api';
import locationIconUrl from '../assets/location.svg?url';
import businessIconUrl from '../assets/business.svg';
import personIconUrl from '../assets/person.svg';


export function RecordKindIcon({recordKind,  size=16, className}: {recordKind: RecordKind, size?: number, className?: string}){
    const IMAGE_MAP : Record<string, string> = {
        'business': businessIconUrl,
        'location': locationIconUrl,
        'person': personIconUrl
    };
    const MARGIN_LEFT_MAP :  Record<string, string> = {
        'business': '-4px',
    };
    return <img
        width={size}
        style={{display: 'inline', marginLeft: MARGIN_LEFT_MAP[recordKind || ''] || '0' }}
        className={className}
        src={IMAGE_MAP[recordKind || ''] || personIconUrl}
    />
}